/*eslint no-unused-vars: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from "react";
import MapBase from "./MapBase";
import { PALETTE_YlOrRd_9, TRANSPARENT_COLOR } from "../../utils/Palette";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {
  arrayToRgb,
  getApiUrl,
  getLastYear,
  makeTableSorterFn,
  numberWithCommas,
} from "../../utils";
import WidgetCodeForStats from "./widgets/WidgetCodeForStats";
import RMateChartFusionResource from "./r_mate_chart/RMateChartFusionResource";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYear from "./widgets/WidgetSelectYear";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import { WELL_KNOWN_POSITION, USER_GBN } from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";

/*
전파자원 분석
 */

function MapFusionResource() {
  const [fillColorLegend, setFillColorLegend] = useState([]);
  const [searchYear, setSearchYear] = useState("");

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: "",
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (feature, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {
          properties: { pk, name },
        } = feature;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const { size, total, density } = obj;
          return `<span class='fontStyle'>${name}</span><br/>
면적 : ${numberWithCommas(size.toFixed(2))} ㎢<br/>
밀도 : ${numberWithCommas(density.toFixed(2))} (국수/㎢)`;
        }
        return `<span class='fontStyle'>${name}</span><br/>
                면적 : 0 ㎢ <br/>
                밀도 : 0 (국수/㎢)`;
      },
      getLevelFillColor: ({ properties: { pk } }, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        // 데이터가 없더라도 색을 입힙니다.
        if (obj) {
          const { total } = metricObject[code] || { total: 1 };
          if (total >= 1) {
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (total - 1)) / metricMax
            );
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      service_code_stats_list: ["2G", "3G", "LTE", "5G"],
      cls_code_stats_list: [
        "32",
        "94",
        "44",
        "85",
        "49",
        "92",
        "42",
        "41",
        "21",
        "CMFL",
        "OTHER",
      ],
      //isClsSearch: false,  // 서비스를 기본 조건으로 둠
      isClsSearch: true, // 무선국종을 기본 조건으로 둠
    },
  });

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats,
    setMapDistrictStats,
    isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    setCurrentDistrictCode,
    currentDistrictCode,
    setGeojsonExtraParams,
    setChartAjaxParams,
    chartAjaxParams,
    setTableAjaxParams,
  } = mapProps;

  const [statsJsonSearchCodeList, setStatsJsonSearchCodeList] = useState([
    "2G",
    "3G",
    "LTE",
    "5G",
  ]);

  /*
   서버 Ajax 통신을 위해 json을 만듭니다.
   */
  const [toJSONList, setToJSONList] = useState(["data"]);

  const settingChkRadSvcString = (checkList) => {
    // const keys = "CHK_VALUE";
    let JSONList = {
      data: [],
    };

    for (let value of checkList) {
      const jsonValue = { CHK_VALUE: value };
      JSONList.data.push(jsonValue);
    }
    setToJSONList(JSONList);
    return JSON.stringify(JSONList);
  };

  const settingLabelList = (clsList) => {
    let labelList = [];
    for (let clsCode of clsList) {
      if (clsCode === "32") labelList.push("기지국");
      else if (clsCode === "94") labelList.push("간이무선국");
      else if (clsCode === "44") labelList.push("육상무선국");
      else if (clsCode === "85") labelList.push("이동중계국");
      else if (clsCode === "49") labelList.push("이동국");
      else if (clsCode === "92") labelList.push("아마추어국");
      else if (clsCode === "42") labelList.push("의무선박국");
      else if (clsCode === "41") labelList.push("선박국");
      else if (clsCode === "21") labelList.push("고정국");
      else if (clsCode === "CMFL") labelList.push("전파응용설비");
      else if (clsCode === "OTHER") labelList.push("기타");
    }
    return labelList;
  };

  // --- 서버 통신을 위한 함수 끝
  const { cls_code_stats_list, service_code_stats_list } = widgetState;

  useEffect(() => {
    const { cls_code_stats_list, service_code_stats_list, isClsSearch } =
      widgetState;

    const { year } = geojsonExtraParams;
    setSearchYear(year);
    window.searchYear = year;

    if (isClsSearch) {
      // 무선국종 검색조건일 경우, 범례를 넘겨줘야함.
      setStatsJsonSearchCodeList(cls_code_stats_list);
      window.prm_check2 = cls_code_stats_list;
      window.prm_check2_label = settingLabelList(cls_code_stats_list);
      window._gubun_code = "cls";
    } else {
      // 서비스 검색조건일 경우
      setStatsJsonSearchCodeList(service_code_stats_list);
      window.prm_check = service_code_stats_list;
      window._gubun_code = "service";
    }

    setChartAjaxParams({
      ...chartAjaxParams,
      searchYear: year,
    });
  }, [widgetState, geojsonExtraParams]);

  useEffect(() => {
    const metricObject = {};
    if (dataResponseList.length > 0 && statsJsonSearchCodeList.length > 0) {
      const firstDataLayer = dataResponseList[0];

      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let size = 0;
        let total = 0;
        let density = 0;
        const firstCode = firstDataLayer[code];
        for (let division_code of statsJsonSearchCodeList) {
          const codeVal = firstCode[division_code];
          if (codeVal) {
            size = codeVal["size"];
            total += codeVal["total"];
          }
        }
        if (total > 1) {
          density = total / size;
        }
        metricObject[code] = { size, total, density };
      }
    }

    const metricMax = Math.max(
      ...Object.values(metricObject).map((obj) => obj.total)
    );

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      /// ajax 통신을 위한 변수세팅
      window.chkRadSvcString = settingChkRadSvcString(statsJsonSearchCodeList);
      window.sidoCode =
        (currentDistrictCode || "").length < 2
          ? ""
          : currentDistrictCode.substr(0, 2);
      window.new_param =
        "sidoCode=" +
        window.sidoCode +
        "&gubun_code=" +
        window._gubun_code +
        "&searchYear=" +
        window.searchYear +
        "&chkRadSvcString=" +
        window.chkRadSvcString;
      //////

      setChartAjaxParams({
        sidoCode: window.sidoCode,
        gubun_code: window._gubun_code,
        searchYear: window.searchYear,
        chkRadSvcString: window.chkRadSvcString,
        prm_check2: cls_code_stats_list,
        prm_check2_label: settingLabelList(cls_code_stats_list),
        prm_check: service_code_stats_list,
      });
    }
  }, [dataResponseList, statsJsonSearchCodeList, currentDistrictCode]);

  /* ////1005_시군구 클릭 임시막기
  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);
*/

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax > 0) {
      setFillColorLegend(
        [...Array(9).keys()]
          .map((colorIndex) => {
            const boundary = (metricMax / 9) * (colorIndex + 1);
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (boundary - 1)) / metricMax
            );
            const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
            return [colorRgb, boundary];
          })
          .reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams((prev) => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    setTableAjaxParams({
      sidoCode: currentDistrictCode || "",
      searchEnd: searchYear,
    });
  }, [currentDistrictCode, searchYear]);

  const { isClsSearch } = widgetState;
  // const [gugunList, setGugunList] = useState();

  const makeColumsByClsSearch = () => {
    return [
      // { title: "순번", dataIndex: "index", key: "index", width: 75, fixed: "left", sorter: makeTableSorterFn("index") },
      {
        title: "구분",
        dataIndex: "data_comment",
        key: "data_comment",
        // sorter: makeTableSorterFn("data_comment"),
      },
      // { title: "구군", dataIndex: "data_field", key: "data_field", sorter: makeTableSorterFn("data_field") },
      {
        title: "합계",
        dataIndex: "data_sum",
        key: "data_sum",
        // sorter: makeTableSorterFn("data_sum"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "기지국",
        dataIndex: "data_32",
        key: "data_32",
        // sorter: makeTableSorterFn("data_32"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "간이무선국",
        dataIndex: "data_94",
        key: "data_94",
        // sorter: makeTableSorterFn("data_94"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "육상이동국",
        dataIndex: "data_44",
        key: "data_44",
        // sorter: makeTableSorterFn("data_44"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "이동중계국",
        dataIndex: "data_85",
        key: "data_85",
        // sorter: makeTableSorterFn("data_85"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "이동국",
        dataIndex: "data_49",
        key: "data_49",
        // sorter: makeTableSorterFn("data_49"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "아마추어국",
        dataIndex: "data_92",
        key: "data_92",
        // sorter: makeTableSorterFn("data_92"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "의무선박국",
        dataIndex: "data_42",
        key: "data_42",
        // sorter: makeTableSorterFn("data_42"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "선박국",
        dataIndex: "data_41",
        key: "data_41",
        // sorter: makeTableSorterFn("data_41"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "고정국",
        dataIndex: "data_21",
        key: "data_21",
        // sorter: makeTableSorterFn("data_21"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "전파응용설비",
        dataIndex: "data_cmfl",
        key: "data_cmfl",
        // sorter: makeTableSorterFn("data_cmfl"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
      {
        title: "기타",
        dataIndex: "data_other",
        key: "data_other",
        // sorter: makeTableSorterFn("data_other"),
        render: (value) =>
          AlignRightText({ text: value, numberComma: true, isParseInt: true }),
      },
    ];
  };

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase
        isHideWidgetToggleClustering={true}
        isHideWidgetMapLayerTypes={true}
      >
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect
              isShowDistrictLayerFromGeoserver={true}
              onlyLv1={true}
            />
            <WidgetSelectYear />
            <Seperator />
            <WidgetCodeForStats />
          </div>
        </WidgetContainer>
        <WidgetRisingTabs titleOnInit={"각 지역에 대한 무선국 점유율(%)"}>
          {isClsSearch ? (
            <WidgetStatisticsTable
              fetchUrl={getApiUrl({ type: "type3" })}
              type={"type3"}
              getTitle={(layer) => `각 지역에 대한 국종별 무선국 점유율(%)`}
              processor={(objectList) => {
                // 지역별서비스별 무선국 밀도 list
                const densityList = objectList.filter(
                  ({ data_type }) => data_type === "DATA_TYPE3"
                );

                const densityObjects = densityList.map(
                  ({
                    data_field,
                    data_sum,
                    data_32,
                    data_94,
                    data_44,
                    data_85,
                    data_49,
                    data_92,
                    data_42,
                    data_41,
                    data_21,
                    data_cmfl,
                    data_other,
                  }) => {
                    let share32 = (data_32 / data_sum) * 100;
                    let share94 = (data_94 / data_sum) * 100;
                    let share44 = (data_44 / data_sum) * 100;
                    let share85 = (data_85 / data_sum) * 100;
                    let share49 = (data_49 / data_sum) * 100;
                    let share92 = (data_92 / data_sum) * 100;
                    let share42 = (data_42 / data_sum) * 100;
                    let share41 = (data_41 / data_sum) * 100;
                    let share21 = (data_21 / data_sum) * 100;
                    let shareCmfl = (data_cmfl / data_sum) * 100;
                    let shareOther = (data_other / data_sum) * 100;
                    return {
                      data_type: "DATA_TYPE4",
                      // , 'data_comment': '지역별서비스별 무선국 점유율(%)'
                      data_column: "",
                      data_field: data_field,
                      data_sum: Math.round(
                        share32 +
                          share94 +
                          share44 +
                          share85 +
                          share49 +
                          share92 +
                          share42 +
                          share41 +
                          share21 +
                          shareCmfl +
                          shareOther
                      ),
                      data_32: Math.round(share32),
                      data_94: Math.round(share94),
                      data_44: Math.round(share44),
                      data_85: Math.round(share85),
                      data_49: Math.round(share49),
                      data_92: Math.round(share92),
                      data_42: Math.round(share42),
                      data_41: Math.round(share41),
                      data_21: Math.round(share21),
                      data_cmfl: Math.round(shareCmfl),
                      data_other: Math.round(shareOther),
                    };
                  }
                );
                const rowList = [...densityObjects];
                const columns = [];
                return [columns, rowList];
              }}
              columns={makeColumsByClsSearch()}
            />
          ) : (
            <WidgetStatisticsTable
              fetchUrl={getApiUrl({ type: "type1" })}
              type={"type1"}
              getTitle={(layer) => `각 지역에 대한 서비스별 무선국 점유율(%)`}
              addDataByAdmin={true}
              processor={(objectList) => {
                // const gugunList = Array.from(new Set(objectList.map(({data_field}) => data_field)));
                // setGugunList(gugunList);

                // 지역별서비스별 무선국 밀도 list
                const densityList = objectList.filter(
                  ({ data_type }) => data_type === "DATA_TYPE3"
                );

                const densityObjects = densityList.map(
                  ({
                    data_field,
                    data_sum,
                    data_2g,
                    data_3g,
                    data_lte,
                    data_5g,
                    data_2g_sk,
                    data_3g_sk,
                    data_lte_sk,
                    data_5g_sk,
                    data_2g_kt,
                    data_3g_kt,
                    data_lte_kt,
                    data_5g_kt,
                    data_2g_lg,
                    data_3g_lg,
                    data_lte_lg,
                    data_5g_lg,
                  }) => {
                    if (USER_GBN && USER_GBN === "2") {
                      // 관리자로 로그인한 경우
                      let share2gSk = (data_2g_sk / data_sum) * 100;
                      let share3gSk = (data_3g_sk / data_sum) * 100;
                      let shareLteSk = (data_lte_sk / data_sum) * 100;
                      let share5gSk = (data_5g_sk / data_sum) * 100;

                      let share2gKt = (data_2g_kt / data_sum) * 100;
                      let share3gKt = (data_3g_kt / data_sum) * 100;
                      let shareLteKt = (data_lte_kt / data_sum) * 100;
                      let share5gKt = (data_5g_kt / data_sum) * 100;

                      let share2gLg = (data_2g_lg / data_sum) * 100;
                      let share3gLg = (data_3g_lg / data_sum) * 100;
                      let shareLteLg = (data_lte_lg / data_sum) * 100;
                      let share5gLg = (data_5g_lg / data_sum) * 100;

                      return {
                        data_type: "DATA_TYPE4",
                        // , 'data_comment': '지역별서비스별 무선국 점유율(%)'
                        data_column: "",
                        data_field: data_field,
                        data_sum: Math.round(
                          share2gSk +
                            share3gSk +
                            shareLteSk +
                            share5gSk +
                            share2gKt +
                            share3gKt +
                            shareLteKt +
                            share5gKt +
                            share2gLg +
                            share3gLg +
                            shareLteLg +
                            share5gLg
                        ),
                        data_2g_sk: Math.round(share2gSk),
                        data_3g_sk: Math.round(share3gSk),
                        data_lte_sk: Math.round(shareLteSk),
                        data_5g_sk: Math.round(share5gSk),

                        data_2g_kt: Math.round(share2gKt),
                        data_3g_kt: Math.round(share3gKt),
                        data_lte_kt: Math.round(shareLteKt),
                        data_5g_kt: Math.round(share5gKt),

                        data_2g_lg: Math.round(share2gLg),
                        data_3g_lg: Math.round(share3gLg),
                        data_lte_lg: Math.round(shareLteLg),
                        data_5g_lg: Math.round(share5gLg),
                      };
                    } else {
                      let share2g = (data_2g / data_sum) * 100;
                      let share3g = (data_3g / data_sum) * 100;
                      let shareLte = (data_lte / data_sum) * 100;
                      let share5g = (data_5g / data_sum) * 100;

                      return {
                        data_type: "DATA_TYPE4",
                        // , 'data_comment': '지역별서비스별 무선국 점유율(%)'
                        data_column: "",
                        data_field: data_field,
                        data_sum: Math.round(
                          share2g + share3g + shareLte + share5g
                        ),
                        data_2g: Math.round(share2g),
                        data_3g: Math.round(share3g),
                        data_lte: Math.round(shareLte),
                        data_5g: Math.round(share5g),
                      };
                    }
                  }
                );
                const rowList = [...densityObjects];
                const columns = [];
                return [columns, rowList];
              }}
              columns={makeColumns()}
              horizontalScroll={60 + 240 + 120 * 4}
            />
          )}
        </WidgetRisingTabs>
        <RMateChartFusionResource
          disabled={
            (!isClsSearch &&
              widgetState.service_code_stats_list.length === 0) ||
            (isClsSearch && widgetState.cls_code_stats_list.length === 0)
          }
        />
        {fillColorLegend.length > 0 && (
          <WidgetLegend
            fillColorLegend={fillColorLegend}
            titleColorLegend={"무선국 수"}
            unitColorLegend={"개"}
          />
        )}
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
}

export const makeColumns = () => {
  if (USER_GBN && USER_GBN === "2") {
    return [
      {
        title: "순번",
        dataIndex: "index",
        key: "index",
        width: 75,
        fixed: "left",
        sorter: makeTableSorterFn("index"),
      },
      // {
      //   title: '구분', dataIndex: 'data_comment', key: 'data_comment', width: 240, fixed: 'left',
      //   sorter: makeTableSorterFn('data_comment')
      // },
      {
        title: "구군",
        dataIndex: "data_field",
        key: "data_field",
        sorter: makeTableSorterFn("data_field"),
      },
      {
        title: "2G",
        children: [
          {
            title: "SK",
            dataIndex: "data_2g_sk",
            key: "data_2g_sk",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_2g_sk"),
          },
          {
            title: "KT",
            dataIndex: "data_2g_kt",
            key: "data_2g_kt",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_2g_kt"),
          },
          {
            title: "LG",
            dataIndex: "data_2g_lg",
            key: "data_2g_lg",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_2g_lg"),
          },
        ],
      },
      {
        title: "3G",
        children: [
          {
            title: "SK",
            dataIndex: "data_3g_sk",
            key: "data_3g_sk",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_3g_sk"),
          },
          {
            title: "KT",
            dataIndex: "data_3g_kt",
            key: "data_3g_kt",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_3g_kt"),
          },
          {
            title: "LG",
            dataIndex: "data_3g_lg",
            key: "data_3g_lg",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_3g_lg"),
          },
        ],
      },
      {
        title: "LTE",
        children: [
          {
            title: "SK",
            dataIndex: "data_lte_sk",
            key: "data_lte_sk",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_lte_sk"),
          },
          {
            title: "KT",
            dataIndex: "data_lte_kt",
            key: "data_lte_kt",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_lte_kt"),
          },
          {
            title: "LG",
            dataIndex: "data_lte_lg",
            key: "data_lte_lg",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_lte_lg"),
          },
        ],
      },
      {
        title: "5G",
        children: [
          {
            title: "SK",
            dataIndex: "data_5g_sk",
            key: "data_5g_sk",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_5g_sk"),
          },
          {
            title: "KT",
            dataIndex: "data_5g_kt",
            key: "data_5g_kt",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_5g_kt"),
          },
          {
            title: "LG",
            dataIndex: "data_5g_lg",
            key: "data_5g_lg",
            render: (value) =>
              AlignRightText({
                text: value.toFixed(1),
                numberComma: true,
                isParseInt: true,
              }),
            sorter: makeTableSorterFn("data_5g_lg"),
          },
        ],
      },
      {
        title: "합계",
        dataIndex: "data_sum",
        key: "data_sum",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_sum"),
      },
    ];
  } else {
    return [
      {
        title: "순번",
        dataIndex: "index",
        key: "index",
        width: 75,
        fixed: "left",
        sorter: makeTableSorterFn("index"),
      },
      // {
      //   title: '구분', dataIndex: 'data_comment', key: 'data_comment', width: 240, fixed: 'left',
      //   sorter: makeTableSorterFn('data_comment')
      // },
      {
        title: "구군",
        dataIndex: "data_field",
        key: "data_field",
        sorter: makeTableSorterFn("data_field"),
      },
      {
        title: "2G",
        dataIndex: "data_2g",
        key: "data_2g",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_2g"),
      },
      {
        title: "3G",
        dataIndex: "data_3g",
        key: "data_3g",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_3g"),
      },
      {
        title: "LTE",
        dataIndex: "data_lte",
        key: "data_lte",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_lte"),
      },
      {
        title: "5G",
        dataIndex: "data_5g",
        key: "data_5g",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_5g"),
      },
      {
        title: "합계",
        dataIndex: "data_sum",
        key: "data_sum",
        render: (value) =>
          AlignRightText({
            text: value.toFixed(1),
            numberComma: true,
            isParseInt: true,
          }),
        sorter: makeTableSorterFn("data_sum"),
      },
    ];
  }
};

export default MapFusionResource;
